module.exports = __webpack_public_path__ + "static/media/14_r_svitok_75.1_89.54.c6249939.png";